import React, { useEffect, useState } from 'react';

const getActivePath = () => {
  const path = window.location.pathname.replace(/\/+$/, '');
  return path || '/about';
};

const PAGE_DETAILS = {
  '/about': { number: '01', label: 'About' },
  '/experience': { number: '02', label: 'Experience' },
  '/projects': { number: '03', label: 'Projects' },
};

const Header = ({ knicksMode, route, navigate }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setMenuOpen(false);
    };
    const handleResize = () => {
      if (window.innerWidth > 768) setMenuOpen(false);
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const activePath = route || getActivePath();
  const currentPage = PAGE_DETAILS[activePath] || PAGE_DETAILS['/about'];

  const handleInternalNavigate = (path) => (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) {
      return;
    }
    event.preventDefault();
    setMenuOpen(false);
    if (navigate) {
      navigate(path);
    } else {
      window.location.pathname = path;
    }
  };

  const handleNavigate = () => {
    setMenuOpen(false);
  };

  return (
    <header>
      <div className="container">
        <nav aria-label="Primary navigation">
          <div className="current-page" aria-label={`Current page: ${currentPage.label}`}>
            <span className="current-page-value">{currentPage.label}</span>
            <span
              className={`knicks-mode-indicator${knicksMode ? ' is-active' : ''}`}
              aria-label={knicksMode ? 'Knicks mode active' : 'Knicks mode inactive'}
              title={knicksMode ? 'Knicks mode active' : 'Knicks mode inactive'}
            />
          </div>
          <span className="sr-only" role="status" aria-live="polite">
            {knicksMode ? 'Knicks mode active' : 'Knicks mode inactive'}
          </span>
          <ul id="primary-nav" className={`nav-links${menuOpen ? ' is-open' : ''}`}>
            <li><a className={activePath === '/about' ? 'active' : ''} aria-current={activePath === '/about' ? 'page' : undefined} href="/about" onClick={handleInternalNavigate('/about')}>About</a></li>
            <li><a className={activePath === '/experience' ? 'active' : ''} aria-current={activePath === '/experience' ? 'page' : undefined} href="/experience" onClick={handleInternalNavigate('/experience')}>Experience</a></li>
            <li><a className={activePath === '/projects' ? 'active' : ''} aria-current={activePath === '/projects' ? 'page' : undefined} href="/projects" onClick={handleInternalNavigate('/projects')}>Projects</a></li>
          </ul>
          <div className="nav-actions">
            <a
              className="surprise-nav-btn"
              href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="/useless (opens YouTube in a new tab)"
              onClick={handleNavigate}
            >
              /useless
            </a>
            <button
              type="button"
              className="menu-toggle"
              aria-expanded={menuOpen}
              aria-controls="primary-nav"
              aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
              onClick={() => setMenuOpen((isOpen) => !isOpen)}
            >
              <svg viewBox="0 0 24 24" aria-hidden="true">
                {menuOpen ? (
                  <path d="M6 6l12 12M18 6 6 18" />
                ) : (
                  <path d="M4 7h16M4 12h16M4 17h16" />
                )}
              </svg>
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
